import { OffsetDateTime } from "@js-joda/core";
import {
  BloodPressureReading,
  BloodPressureReadingApiDto,
  toBloodPressureReading,
} from "./BloodPressureReading";

export type BloodPressureObservation = {
  id: string;
  dateTime: OffsetDateTime;
  reading: BloodPressureReading;
};

export type BloodPressureObservationDto = {
  dateTime: string;
  reading: BloodPressureReadingApiDto;
};

export const toBloodPressureObservation = ({
  dateTime,
  reading,
}: BloodPressureObservationDto): BloodPressureObservation => ({
  id: reading.id,
  dateTime: OffsetDateTime.parse(dateTime),
  reading: toBloodPressureReading(reading),
});
